export default __webpack_public_path__ + "static/media/noteAssess.5c644a07.svg";